<template>
    <div>
        <form @submit.prevent="submit" autocomplete="off">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6">
                                    <legend>{{ $t("componenttype.General") }}</legend>
                                    <label for="customer_id">{{ $t("component.CustomerId") }}*</label>
                                    <vue-bootstrap-typeahead
                                            :data="customerResults"
                                            :serializer="item => item.name"
                                            @hit="customerSelect($event.id)"
                                            id="customer_id"
                                            name="customer_id"
                                            placeholder="Search customer..."
                                            ref="customersAutocomplete"
                                            type="text"
                                            v-bind:inputClass="this.customer_id.validated ? this.customer_id.valid ? 'is-valid' : 'is-invalid' : ''"
                                            v-model="customerSearch"
                                            v-validate="'required'"
                                    />
                                    <div class="invalid-feedback feedback-typeahead">{{
                                        errors.first('customer_id') }}
                                    </div>
                                    <div class="form-label-group mt-4">
                                        <component-types-dropdown :allTypes="true" id="component_type_id"
                                                                  name="component_type_id"
                                                                  v-bind:class="[this.component_type_id.validated ? this.component_type_id.valid ? 'is-valid' : 'is-invalid' : '']"
                                                                  v-model="form.component_type_id"
                                                                  v-validate="'required'"></component-types-dropdown>
                                        <div class="invalid-feedback">{{ errors.first('component_type_id') }}</div>
                                    </div>
                                    <div class="form-label-group">
                                        <brands-dropdown id="brand_id" name="brand_id"
                                                         v-bind:class="[this.brand_id.validated ? this.brand_id.valid ? 'is-valid' : 'is-invalid' : '']"
                                                         v-model="form.brand_id"
                                                         v-validate="'required'"></brands-dropdown>
                                        <div class="invalid-feedback">{{ errors.first('brand_id') }}</div>
                                    </div>

                                    <div class="row">
                                        <div class="col-8">
                                            <div class="form-label-group">
                                                <component-global-type-dropdown id="type" name="type"
                                                                                v-bind:class="[this.type.validated ? this.type.valid ? 'is-valid' : 'is-invalid' : '']"
                                                                                v-model="form.type"
                                                                                v-validate="'required'"></component-global-type-dropdown>
                                                <div class="invalid-feedback">{{ errors.first('type') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8">
                                            <div class="form-label-group">
                                                <input class="form-control" id="packet_number" name="packet_number"
                                                       placeholder="Enter customer"
                                                       type="text"
                                                       v-bind:class="[this.packet_number.validated ? this.packet_number.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.packet_number"
                                                       v-validate="'required'">
                                                <label for="packet_number">{{ $t("component.PacketNumber") }}*</label>
                                                <div class="invalid-feedback">{{ errors.first('packet_number') }}</div>
                                                <small class="form-text text-muted">
                                                    The number of the full process component packet, e.g. ARD12
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8">
                                            <div class="form-label-group">
                                                <input class="form-control" id="number" name="number"
                                                       placeholder="Enter customer"
                                                       type="text"
                                                       v-bind:class="[this.number.validated ? this.number.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.number"
                                                       v-validate="'required'">
                                                <label for="number">{{ $t("component.Number") }}*</label>
                                                <div class="invalid-feedback">{{ errors.first('number') }}</div>
                                                <small class="form-text text-muted">
                                                    The number of the sub part from the process component, e.g. 100
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-8">
                                            <div class="form-label-group">
                                                <input class="form-control" id="interval_control"
                                                       name="interval_control"
                                                       placeholder="Enter customer"
                                                       type="text"
                                                       v-bind:class="[this.interval_control.validated ? this.interval_control.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.interval_control"
                                                       v-validate="'required|integer'">
                                                <label for="interval_control">{{ $t("component.IntervalControl")
                                                    }}*</label>
                                                <small class="form-text text-muted">
                                                    The number of months to recheck the component, e.g. 12 (1 year)
                                                </small>
                                                <div class="invalid-feedback">{{ errors.first('interval_control') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <legend>{{ $t("componenttype.MinMax") }}</legend>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.pollution")}}</label>
                                        </div>
                                        <div class="offset-4 col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_pollution_rate"
                                                       name="max_pollution_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_pollution_rate.validated ? this.max_pollution_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_pollution_rate"
                                                       v-validate="'required|between:1,5'">
                                                <label for="max_pollution_rate">{{
                                                    $t("component.Max")}}*</label>
                                                <div class="invalid-feedback">{{ errors.first('max_pollution_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.wear")}}</label>
                                        </div>
                                        <div class="offset-4 col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_wear_rate" name="max_wear_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_wear_rate.validated ? this.max_wear_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_wear_rate"
                                                       v-validate="'required|between:1,5'">
                                                <label for="max_wear_rate">{{ $t("component.Max")
                                                    }}*</label>
                                                <div class="invalid-feedback">{{ errors.first('max_wear_rate') }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.weight")}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="min_weight_rate" name="min_weight_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.min_weight_rate.validated ? this.min_weight_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.min_weight_rate">
                                                <label for="min_weight_rate">{{
                                                    $t("component.Min")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('min_weight_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_weight_rate" name="max_weight_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_weight_rate.validated ? this.max_weight_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_weight_rate">
                                                <label for="max_weight_rate">{{
                                                    $t("component.Max")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('max_weight_rate') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>{{$t("component.backpressure")}}</label>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="min_back_pressure_rate"
                                                       name="min_back_pressure_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.min_back_pressure_rate.validated ? this.min_back_pressure_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.min_back_pressure_rate">
                                                <label for="min_back_pressure_rate">{{
                                                    $t("component.Min")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('min_back_pressure_rate')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-label-group">
                                                <input class="form-control" id="max_back_pressure_rate"
                                                       name="max_back_pressure_rate"
                                                       placeholder="Enter customer"
                                                       type="number"
                                                       v-bind:class="[this.max_back_pressure_rate.validated ? this.max_back_pressure_rate.valid ? 'is-valid' : 'is-invalid' : '']"
                                                       v-model="form.max_back_pressure_rate">
                                                <label for="max_back_pressure_rate">{{
                                                    $t("component.Max")}}</label>
                                                <div class="invalid-feedback">{{ errors.first('max_back_pressure_rate')
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <legend>Extra</legend>
                                    <div class="form-label-group">
                                        <textarea class="form-control" id="note" name="note"
                                                  placeholder="Enter your Message"
                                                  rows="3" v-model="form.note"></textarea>
                                        <label for="note">{{$t('component.Note')}}</label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="form.status" type="checkbox" class="form-check-input" id="exampleCheck1">
                                        <label class="form-check-label" for="exampleCheck1">Active</label>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit">{{$t('global.Submit')}}</button>
                            <button @click="reset()" class="btn btn-outline-default ml-2" type="button"
                                    v-if="isNew">
                                {{$t('global.Reset')}}
                            </button>
                            <button @click="deleteComponent()" class="btn btn-neutral red ml-2" type="button"
                                    v-if="!isNew">
                                {{$t('global.Delete')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'
    import ComponentTypesDropdown from '@/components/ComponentTypesDropdown.vue'
    import ComponentGlobalTypeDropdown from '@/components/ComponentGlobalTypeDropdown.vue'
    import BrandsDropdown from '@/components/BrandsDropdown.vue'
    import _ from 'underscore'

    export default {
        name: 'appCreate',
        data() {
            return {
                isNew: true,
                dispatchLink: 'SAVE_COMPONENT',
                error: '',
                checkbox: true,
                customerResults: [],
                customerSelected: null,
                customerSearch: '',
                typesLoaded: false,
                brandsLoaded: false,
                form: this.initForm()
            }
        },
        components: {
            ComponentTypesDropdown,
            BrandsDropdown,
            ComponentGlobalTypeDropdown
        },
        computed: {
            ...mapFields([
                'customer_id',
                'component_type_id',
                'number',
                'packet_number',
                'interval_control',
                'brand_id',
                'max_pollution_rate',
                'max_wear_rate',
                'type',
                'max_weight_rate',
                'min_weight_rate',
                'max_back_pressure_rate',
                'min_back_pressure_rate',
                'max_leakage_rate',
                'min_leakage_rate']),
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.form.current_customer_id = this.$route.params.customer_id;
                        this.$store.dispatch(this.dispatchLink, this.form)
                            .then(() => {
                                this.$swal({
                                    title: this.$t('swal.logout.SuccessTitle'),
                                    text: this.$t('swal.logout.SuccessMsg'),
                                    type: "success",
                                    toast: true,
                                    showConfirmButton: false,
                                    position: 'top-end',
                                    timer: 1200
                                });

                                if (this.isNew) {
                                    //Form leegmaken
                                    this.form.number = ''
                                    this.form.note = ''
                                    this.$validator.reset()
                                }

                                document.getElementById("number").focus()
                            })
                            .catch((error) => {
                                if (error.errors.name) {
                                    this.$validator.errors.add({
                                        field: 'name',
                                        msg: error.errors.name[0]
                                    })
                                    this.fieldsVee.name.valid = false
                                }
                                if (error.errors.app_id) {
                                    this.$validator.errors.add({
                                        field: 'app_id',
                                        msg: error.errors.app_id[0]
                                    })
                                    this.fieldsVee.app_id.valid = false
                                }
                                if (error.errors.token) {
                                    this.$validator.errors.add({
                                        field: 'token',
                                        msg: error.errors.token[0]
                                    })
                                    this.fieldsVee.token.valid = false
                                }


                            })
                    }
                })
            },
            deleteComponent() {
                //Confirmation dialog, are you sure?
                this.$swal({
                    title: this.$t('swal.general.Title'),
                    text: this.$t('swal.delete.Text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: this.$t('swal.general.CancelButtonText'),
                    confirmButtonText: this.$t('swal.delete.ConfirmButtonText')
                }).then(async (result) => {
                        //Sure? -> Delete
                        if (result.value) {

                            let resp = await this.$store.dispatch('DELETE_COMPONENT', this.form)

                            //Success message
                            this.$swal({
                                title: this.$t('swal.delete.SuccessTitle'),
                                text: resp.message,
                                type: "success",
                                toast: true,
                                showConfirmButton: false,
                                position: 'top-end',
                                timer: 1200
                            });

                            //Terugsturen naar index
                            this.$router.push({name: 'measurementIndex'})
                        }
                    }
                )
                    .catch(error => {
                      this.$swal({
                        title: 'There is a problem..',
                        text: 'U hebt geen rechten om een component te verwijderen.',
                        type: "error",
                        toast: false,
                        showConfirmButton: true,
                        position: 'top-end',
                        // timer: 1200
                      });
                    })
            },
            //Customers ophalen via autocomplete
            async getCustomers(query) {
                await this.$store.dispatch('DROPDOWN_CUSTOMER', query).then((res) => {
                    this.customerResults = res
                })
            },
            async loadFormData() {
                //Als de twee dropdowns zijn ingeladen -> form inladen
                if (this.brandsLoaded == true && this.typesLoaded == true) {
                    //Check create or update
                    this.isNew = true;
                    this.dispatchLink = 'SAVE_COMPONENT';
                    if (this.$route.params.id) {
                        if (this.typesLoaded) {
                            this.isNew = false;
                            this.dispatchLink = 'UPDATE_COMPONENT';

                            let component = await this.$store.dispatch('GET_COMPONENT', {
                                id: this.$route.params.id,
                                customer_id: this.$route.params.customer_id
                            })

                            this.form = component

                            this.customerSearch = component.relations.customer.name
                            this.$refs.customersAutocomplete.$data.inputValue = component.relations.customer.name

                        }
                    }
                }
            },
            async customerSelect(id) {
                await this.$store.dispatch('DROPDOWN_TYPES');
                this.form.customer_id = id;
            },
            reset() {
                this.form = this.initForm()
            },
            initForm() {
                this.$validator.reset()
                this.lastMeasurement = null
                return {
                    current_customer_id: '',
                    customer_id: '',
                    component_type_id: '',
                    brand_id: '',
                    number: '',
                    packet_number: '',
                    interval_control: '',
                    max_wear_rate: '',
                    max_pollution_rate: '',
                    note: '',
                    type: 1,
                    max_weight_rate: '',
                    min_weight_rate: '',
                    max_back_pressure_rate: '',
                    min_back_pressure_rate: '',
                    max_leakage_rate: '',
                    min_leakage_rate: '',
                    status: 1
                }
            },
        },
        watch: {
            customerSearch: _.debounce(function (addr) {
                this.getCustomers(addr)
            }, 500),
            //Wachten op dropdowns om in te laden
            brandsLoaded: async function () {
                //Eerst brands inladen, daarna types inladen -> daarna form invullen
                if (this.$route.params.customer_id) {
                    await this.customerSelect(this.$route.params.customer_id)
                    this.typesLoaded = true
                    //Als alles ingeladen is, form inladen
                    this.loadFormData()
                }
            }
        }
    }
</script>
